import Vue from 'vue'
import Router from 'vue-router'
// import { LFeatureGroup } from 'vue2-leaflet';

Vue.use(Router);

export const asyncRouterMap = [
  /** When your routing table is too long, you can split it into small modules**/
  {
    path: '/404',
    name: '404',
    hidden: true,
    meta: { layout: 'userpages' },
    component: () => import('@/pages/error/404.vue'),
  },
  {
    path: '/login',
    name: 'login',
    hidden: true,
    meta: { layout: 'userpages' },
    component: () => import('@/pages/login/Login.vue'),
  },
  {
    path: '/',
    name: 'main',
    title: '메인화면',
    icon: 'dashboard',
    meta: { layout: 'default', editable: true, },
    component: () => import('@/pages/main/index.vue'),
  },
  {
    path: '/sop/swp/safeWorkPermit',
    name: 'MENU000045',
    title: '작업허가서',
    icon: 'home_repair_service',
    meta: { layout: 'default', editable: true, },
    component: () => import('@/pages/sop/swp/safeWorkPermit.vue'),
  },
  {
    path: '/sop/swp/safeWorkPermitVendor',
    name: 'safeWorkPermitVendor',
    title: '업체 작업허가서',
    icon: 'home_repair_service',
    meta: { layout: 'default', editable: true, },
    component: () => import('@/pages/sop/swp/safeWorkPermitVendor.vue'),
  },
  {
    path: '/sop/cto/cto',
    name: 'MENU000163',
    title: '안전보건팀 패트롤',
    icon: 'fact_check',
    meta: { layout: 'default', editable: true, },
    component: () => import('@/pages/sop/cto/cto.vue'),
  },
  {
    path: '/sai/patrol/patrol',
    name: 'MENU000220',
    title: '안전환경 점검반',
    icon: 'change_circle',
    meta: { layout: 'default', editable: true, },
    component: () => import('@/pages/sai/patrol/patrol.vue'),
  },
  {
    path: '/env/ptr/envPatrol',
    name: 'MENU000275',
    title: '환경팀 패트롤',
    icon: '360',
    meta: { layout: 'default', editable: true, },
    component: () => import('@/pages/env/ptr/envPatrol.vue'),
  },
  {
    path: '/sop/ibm/impr',
    name: 'MENU000068',
    title: '개선관리',
    icon: 'construction',
    meta: { layout: 'default', editable: true, },
    component: () => import('@/pages/sop/ibm/impr.vue'),
  },
  {
    path: '/sai/sob/safOpinionBoard',
    name: 'MENU000299',
    title: '근로자안전보건제안',
    icon: 'content_paste',
    meta: { layout: 'default', editable: true, },
    component: () => import('@/pages/sai/sob/safOpinionBoard.vue'),
  },
  // {
  //   path: '/sop/ibm/imprVendor',
  //   name: 'imprVendor',
  //   title: '협력업체 개선관리',
  //   icon: 'construction',
  //   meta: { layout: 'default', editable: true, },
  //   component: () => import('@/pages/sop/ibm/imprVendor.vue'),
  // },
  // {
  //   path: '/sop/ibm/imprSupple',
  //   name: 'MENU000268',
  //   title: '개선 유효성평가',
  //   icon: 'construction',
  //   meta: { layout: 'default', editable: true, },
  //   component: () => import('@/pages/sop/ibm/imprSupple.vue'),
  // },
  // {
  //   path: '/sop/mim/inspection/equipmentDailyInspection',
  //   name: 'MENU000244',
  //   title: '일상점검',
  //   icon: 'engineering',
  //   meta: { layout: 'default', editable: true, },
  //   component: () => import('@/pages/sop/mim/inspection/equipmentDailyInspection.vue'),
  // },
  // {
  //   path: '/sop/mim/inspection/equipmentDeteriorInspection',
  //   name: 'MENU000245',
  //   title: '열화관리점검',
  //   icon: 'plumbing',
  //   meta: { layout: 'default', editable: true, },
  //   component: () => import('@/pages/sop/mim/inspection/equipmentDeteriorInspection.vue'),
  // },
  // {
  //   path: '/sop/mim/inspection/equipmentUtilityInspection',
  //   name: 'MENU000250',
  //   title: '유틸리티점검',
  //   icon: 'engineering',
  //   meta: { layout: 'default', editable: true, },
  //   component: () => import('@/pages/sop/mim/inspection/equipmentUtilityInspection.vue'),
  // },
  // {
  //   path: '/sop/mim/hazardEquipment/hazardFocusInspection',
  //   name: 'MENU000239',
  //   title: '중점점검',
  //   icon: 'notification_important',
  //   meta: { layout: 'default', editable: true, },
  //   component: () => import('@/pages/sop/mim/hazardEquipment/hazardFocusInspection.vue'),
  // },
  // {
  //   path: '/sop/mim/inspection/safetyCheck',
  //   name: 'MENU000261',
  //   title: '관리감독자점검',
  //   icon: 'manage_accounts',
  //   meta: { layout: 'default', editable: true, },
  //   component: () => import('@/pages/sop/mim/inspection/safetyCheck.vue'),
  // },
  // {
  //   path: '/env/hcf/hazardFacilitySelfCheck',
  //   name: 'MENU000228',
  //   title: '취급시설 자체점검',
  //   icon: 'room_preferences',
  //   meta: { layout: 'default', editable: true, },
  //   component: () => import('@/pages/env/hcf/hazardFacilitySelfCheck.vue'),
  // },
  // {
  //   path: '/sop/edu/result/educationResult',
  //   name: 'MENU000048',
  //   title: '교육이수',
  //   icon: 'school',
  //   meta: { layout: 'default', editable: true, },
  //   component: () => import('@/pages/sop/edu/result/educationResult.vue'),
  // },
  // {
  //   path: '/sop/iim/near/nearAccident',
  //   name: 'MENU000059',
  //   title: '아차사고',
  //   icon: 'personal_injury',
  //   meta: { layout: 'default', editable: true, },
  //   component: () => import('@/pages/sop/iim/near/nearAccident.vue'),
  // },
  {
    path: '/sys/appr/doc/apprTodo',
    name: 'MENU000156',
    title: '결재할 문서',
    icon: 'assignment_turned_in',
    meta: { layout: 'default', editable: true, },
    component: () => import('@/pages/sys/appr/doc/apprTodo.vue'),
  },
  // {
  //   path: '/sys/appr/qrreader',
  //   name: 'MENU000999',
  //   title: 'QR리더기',
  //   icon: 'qr_code',
  //   meta: { layout: 'default', editable: true, },
  //   component: () => import('@/pages/sys/appr/qrreader.vue'),
  // },
  // {
  //   path: '/sop/mim/inspection/equipmentQrSelect',
  //   name: 'qrSelect',
  //   hidden: true,
  //   title: '', // 열화/일상 선택
  //   meta: { layout: 'default', editable: true, },
  //   component: () => import('@/pages/sop/mim/inspection/equipmentQrSelect.vue'),
  // },
];

export default new Router({
    scrollBehavior() {
        return window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    routes: asyncRouterMap,
    mode: 'history', // # 제거
})
